import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "emq-table-footer" }

import { ref, computed, watch, nextTick } from 'vue'
// import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import useI18nTl from '@/hooks/useI18nTl'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import SelectEvseModel from '@/components/SelectEvseModel.vue'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectEvseFirmware from '@/components/SelectEvseFirmware.vue'
import { retryOta, addEvseOta, listEvse } from '@/api/evses'
import { ElMessage, ElMessageBox } from 'element-plus'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { Search } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import EvseStatusSimple from '@/components/EvseStatusSimple.vue'
import FormRulesFactory from '@/common/formRules'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseOTADrawer',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { emit }) {

const props = __props

const otaFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['operatorID', 'modelId', 'firmwareId'],
    'selectNone',
    'selectNone',
  ),
})

const { tl, t } = useI18nTl('Evses')



// const evseIds = ref([]) // 选中的行数据
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext({
  // limit: 2,
})
const { updateParams } = usePaginationRemember('evses-detail')

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadEvses({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, sn, firewareVersion } = params
  newParams = {
    id: id || undefined,
    sn: sn || undefined,
    firewareVersion: firewareVersion || undefined,
  }
  return newParams
}
const selectedSn = ref<string[]>([])

const handleSelectionChange = (selection: any) => {
  const ids = selection.map((row: any) => row.id)
  const sns = selection.map((row: any) => row.evseSN) // 获取选中项的 sn

  // 更新 evseIds 数组，添加新选中的ID
  record.value.evseIds = [...new Set([...record.value.evseIds, ...ids])]
  // 更新 selectedSn 数组，添加新选中的 sn
  selectedSn.value = [
    ...new Set([
      ...selectedSn.value.filter((sn) => !sns.includes(sn)), // 保留不需要移除的 sn
      ...sns, // 添加新的选中项的 sn
    ]),
  ]
  // 移除取消选中的ID
  const unselected = tableData.value.filter((row: any) => !ids.includes(row.id))

  console.log('--->handleSelectionChange ids: ', ids)
  console.log('--->handleSelectionChange unselected: ', unselected)

  unselected.forEach((row: any) => {
    const index = record.value.evseIds.indexOf(row.id)
    if (index > -1) {
      record.value.evseIds.splice(index, 1)
    }
    const snIndex = selectedSn.value.indexOf(row.evseSN)
    if (snIndex > -1) {
      selectedSn.value.splice(snIndex, 1)
    }
  })
}

const showSelectedRow = () => {
  // handleSelectionChangeDisable.value = true;
  // TableCom.value!.off('selection-change', handleSelectionChange);

  // TableCom.value.clearSelection();
  let selectItem = []
  tableData.value.forEach((row: any) => {
    console.log(
      '---->showSelectedRow: ',
      record.value.evseIds,
      row.id,
      record.value.evseIds.includes(row.id),
    )
    if (record.value.evseIds.includes(row.id)) {
      // selectItem.push(row)
      TableCom.value!.toggleRowSelection(row, true)
    } else {
      TableCom.value!.toggleRowSelection(row, false)
    }
  })

  // TableCom.value.toggleRowSelection(selectItem, true);
  // handleSelectionChangeDisable.value = false;
  // TableCom.value!.on('selection-change', handleSelectionChange);
}

const getRowKey = (row: any) => {
  return row.id
}

const rowClick = (row: any) => {
  TableCom.value.toggleRowSelection(row, true)
}

const loadEvses = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
    operatorId: record.value.operatorID,
    modelId: record.value.modelId,
  }
  if (sendParams.modelId == '') {
    sendParams.modelId = '0'
  }
  if (sendParams.modelId == '0') {
    console.log('modelId is 0')
    lockTable.value = false
    tableData.value = []
    return
  }

  try {
    const { list = [], pageReply = {} } = await listEvse(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })

    nextTick(() => {
      showSelectedRow()
    })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

let subsForm = ref()
const record = ref<Record<string, any>>({
  modelId: '',
  evseIds: [],
})
const showDialog = computed({
  get: () => {
    subsForm.value?.clearValidate()
    return props.modelValue
  },
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const submit = async () => {
  await subsForm.value?.validate()

  addEvseOta(record.value)
    .then((res: any) => {
      ElMessage.success(t(`Base.createSuccess`))
      showDialog.value = false
      record.value = {}
      emit('submitted')
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}

watch(
  () => record.value.modelId,
  (val) => {
    loadEvses()
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _unref(tl)('addEvseOTA'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: otaFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorID",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: record.value.operatorID,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.operatorID) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.model'),
                    prop: "modelId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectEvseModel, {
                        modelValue: record.value.modelId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.modelId) = $event)),
                        operatorID: record.value.operatorID,
                        name: record.value.model,
                        disabled: 
                record.value.operatorID == '0' ||
                record.value.operatorID == '' ||
                record.value.operatorID == undefined
              ,
                        placeholder: _unref(tl)('selectEvseModle'),
                        onChanges: loadEvses
                      }, null, 8, ["modelValue", "operatorID", "name", "disabled", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('firmware'),
                    prop: "firmwareId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectEvseFirmware, {
                        modelValue: record.value.firmwareId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.firmwareId) = $event)),
                        modelID: record.value.modelId,
                        disabled: 
                record.value.modelId == '0' || record.value.modelId == '' || record.value.modelId == undefined
              
                      }, null, 8, ["modelValue", "modelID", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('selectedEvses'),
                    prop: "evseIds"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 3,
                        modelValue: selectedSn.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedSn).value = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('selectOtaEvses')
                  }, null, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    onKeyup: _withKeys(handleSearch, ["enter"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 18 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: fuzzyParams.value.sn,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fuzzyParams.value.sn) = $event)),
                                placeholder: _ctx.$t('Evses.sn'),
                                clearable: "",
                                onClear: handleSearch
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                plain: "",
                                icon: _unref(Search),
                                onClick: handleSearch
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                                ]),
                                _: 1
                              }, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onKeyup"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: tableData.value,
                    ref_key: "TableCom",
                    ref: TableCom,
                    "row-key": getRowKey,
                    onRowClick: rowClick,
                    onSelectionChange: handleSelectionChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "30",
                        "reserve-selection": true
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "evseSN",
                        "min-width": "80",
                        label: _ctx.$t('Evses.sn'),
                        align: "center"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_tooltip, {
                            content: row.id,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(PreWithEllipsis, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.evseSN), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "operatorName",
                        "min-width": "80",
                        label: _ctx.$t('Evses.operatorName'),
                        show: "false"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "state",
                        "min-width": "80",
                        label: _ctx.$t('Evses.state')
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(EvseStatusSimple, {
                            state: row.state
                          }, null, 8, ["state"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "firmwareVersion",
                        "min-width": "100",
                        label: _ctx.$t('Evses.firmwareVersion')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [
                      _directive_loading,
                      lockTable.value,
                      void 0,
                      { lock: true }
                    ]
                  ]),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(CommonPagination, {
                      metaData: _unref(pageMeta),
                      "onUpdate:metaData": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
                      pageSizeOpt: [10, 20],
                      onLoadPage: loadEvses
                    }, null, 8, ["metaData"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})